app.controller("EmployeeOutgoingDocumentsController", [
    "$scope", "$stateParams", "StaticData", "DocumentsService", "AuthService", "Socket", "$state", "usSpinnerService", "toastr", "$uibModal", "$httpParamSerializer",
    function ($scope, $stateParams, StaticData, DocumentsService, AuthService, Socket, $state, usSpinnerService, toastr, $uibModal, $httpParamSerializer) {
        $scope.documents = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.format = "dd-MM-yyyy";
        $scope.author = null;
        $scope.addressee = null;
        $scope.comment = $stateParams.comment;
        $scope.uniqueNumber = $stateParams.uniqueNumber;
        $scope.type = $stateParams.type || null;
        $scope.documentTypes = {
            'OUTGOING': []
        };

        if ($stateParams.addressee) {
            usSpinnerService.spin("root");
            DocumentsService.sendersList({ query: $stateParams.addressee }).then(function (senders) {
                if (!senders.length) {
                    return;
                }
                $scope.addressee = senders[0];
                usSpinnerService.stop("root");
            });
        }

        if ($stateParams.author) {
            usSpinnerService.spin("root");
            DocumentsService.getEmployee($stateParams.author).then(function (emp) {
                $scope.author = {
                    _id: emp.profile,
                    user: emp.user,
                    positionInfo: {
                        position: emp.position,
                        organization: emp.organization
                    }
                };
                usSpinnerService.stop("root");
            });
        }
        var socket = new Socket("/documents");

        socket.on('review', function (document) {
            $scope.documents.unshift(document);
            $scope.totalItems = $scope.documents.length;
        });

        socket.on('reviewed', function () {
            $scope.loadPage();
        });

        StaticData.getItemsByKey("document_types").then(function (types) {
            $scope.documentTypesMap = _.keyBy(types, '_id');
        });

        function getDocumentTypes() {
            usSpinnerService.spin("root");
            DocumentsService.typeList({ admin: true }).then(function (data) {
                data.forEach(function (type) {
                    if (type.parentId === 'OUTGOING') {
                        $scope.documentTypes[type.parentId].push(type);
                    }
                });
                usSpinnerService.stop("root");
            }).catch(function () {
                usSpinnerService.spin("root");
                toastr.error('', 'დაფიქსირდა შეცდომა');
            });
        }

        getDocumentTypes();

        $scope.applyFilter = function () {
            $state.go('.', {
                author: $scope.author ? $scope.author._id : null,
                uniqueNumber: $scope.uniqueNumber ? $scope.uniqueNumber : null,
                comment: $scope.comment,
                type: $scope.type,
                addressee: $scope.addressee ? $scope.addressee.id : null,
            });
        }

        $scope.loadPage = function () {
            usSpinnerService.spin("root");

            DocumentsService.externalDocumentsList({
                baseType: 'OUTGOING',
                type: $scope.type,
                page: $stateParams.page,
                limit: $scope.itemsPerPage,
                comment: $scope.comment,
                uniqueNumber: $scope.uniqueNumber,
                author: $scope.author && $scope.author.id ? $scope.author.id : $stateParams.author,
                addressee: $scope.addressee && $scope.addressee._id ? $scope.addressee._id : $stateParams.addressee
            }).then(function (res) {
                $scope.documents = res.data.docs;
                $scope.totalItems = res.data.total;
                $scope.currentPage = $stateParams.page;
                usSpinnerService.stop("root");
            });
        };

        $scope.loadPage();

        $scope.exportExternal = function () {
            var qs = $httpParamSerializer({
                baseType: 'OUTERGOING',
                type: $scope.type,
                comment: $scope.comment,
                uniqueNumber: $scope.uniqueNumber,
                author: $scope.author && $scope.author.id ? $scope.author.id : $stateParams.author,
                addressee: $scope.addressee && $scope.addressee._id ? $scope.addressee._id : $stateParams.addressee,
            });
            window.open('/documents/list/baseType/export?' + qs);
        };

        $scope.changePage = function () {
            $state.go(".", { page: $scope.currentPage });
        };

        $scope.getEmployees = function (name) {
            if (name.length < 1) {
                return [];
            }
            return DocumentsService.staffList({
                query: name
            }).then(function (data) {
                return data.docs;
            });
        };

        $scope.getSenders = function (query) {
            if (query.length < 1) {
                return [];
            }
            return DocumentsService.sendersList({ query: query });
        };

        $scope.open = function (actionType, docId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $state.go('employee.documents.view', { actionType: actionType, documentId: docId, returnUrl: window.location.href })
        };

        $scope.select = function (docId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
        };

        $scope.download = function (url, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open(url);
        };

        $scope.add = function () {
            $state.go('employee.documents.new-outgoing');
        };

        $scope.printCheck = function ($event, _id) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open('documents/external/check/' + _id);
        }

        $scope.generateTooltip = function (document) {
            if (document.chancelleryStatus === 'returned') {
                return 'მობრუნებულია კანცელარიის მიერ';
            } else if (document.status && document.status === "done") {
                return 'შესრულებული';
            } else {
                return 'მიმდინარე';
            }
        };

        $scope.generateClass = function (document) {
            if (document.chancelleryStatus === 'returned') {
                return 'doc-returned';
            } else if (document.status && document.status === "done") {
                return 'doc-done';
            } else {
                return 'doc-read';
            }

        };

        $scope.showComment = function (comment, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "CommentWindowController",
                templateUrl: _pb + 'employee/documents/comment-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            comment: comment,
                            action: 'view',
                            header: 'კანცელარიის'
                        };
                    }
                }
            })
        };

        $scope.selectAll = function () {
            angular.forEach($scope.documents, function (el) {
                if (el.status === 'done' && !el.finalDate) {
                    el.checked = true;
                }
            });
        };

        $scope.selectNone = function () {
            angular.forEach($scope.documents, function (el) {
                el.checked = false;
            });
        };

        $scope.finalizeSelected = function () {
            var selected = $scope.documents.filter(function (el) {
                return el.checked === true;
            });
            if (selected.length < 1) {
                InfoModal.show({ title: "ინფორმაცია", message: "გთხოვთ მონიშნოთ მინიმუმ ერთი დოკუმენტი" });
                return;
            }
            $scope.finalizeMany(selected);
        };

        $scope.finalizeMany = function (documents, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "FinalizeReviewedModalController",
                templateUrl: _pb + 'employee/documents/finalize-reviewed-modal.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            documents: documents
                        };
                    }
                }
            }).result
                .then(function () {
                    loadPage($stateParams.page).then(function () {
                        $scope.currentPage = $stateParams.page;
                    });
                }, function () {
                });
        };

        $scope.finalize = function (document, $event) {
            $scope.finalizeMany([document], $event);
        };

        $scope.share = function (documentId, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EmployeeShareDocumentController",
                templateUrl: _pb + 'employee/documents/employee-share-document.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            documentId: documentId
                        };
                    }
                }
            });
        };
        $scope.getReceiverInfo = function(doc){
           return ((((doc.features || {}).baseType || {}).OUTGOING || {}).addressees|| []).map(add=>add.name + '('+add.id+')').toString()
        }
    }

]);
